import React from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';
import { format, parseISO } from 'date-fns';
import DataTimeDisplay from './DataTimeDisplay';
import ScheduleDetails from './ScheduleDetails';

const detailTitleStyle = {
  fontWeight: 'medium',
  mb: 1,
};

const JobDetails = ({ job }) => (
  <Box sx={{ p: 2, bgcolor: 'background.paper', ml: 4, mr: 2, mb: 2, borderRadius: 1 }}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Data Time Configuration</Typography>
          <Divider sx={{ my: 1 }} />
          <DataTimeDisplay config={job.dataTimeConfig} />
        </Box>
        <Box>
          <Typography variant="subtitle2">Source Filters</Typography>
          <Divider sx={{ my: 1 }} />
          {job.sourceFilters?.length > 0 ? (
            job.sourceFilters.map((filter, idx) => (
              <Box key={idx} sx={{ mb: 1 }}>
                <Typography variant="body2" component="span" sx={{ fontWeight: 'medium' }}>
                  {filter.name}:
                </Typography>{' '}
                <Typography variant="body2" component="span">
                  {filter.values.join(', ')}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No filters applied
            </Typography>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Schedule Configuration</Typography>
          <Divider sx={{ my: 1 }} />
          <ScheduleDetails config={job.scheduleConfig} />
        </Box>
        <Box>
          <Typography variant="subtitle2">Additional Information</Typography>
          <Divider sx={{ my: 1 }} />
          <Typography variant="body2">Created by: {job.createdBy}</Typography>
          <Typography variant="body2">
            Created at: {format(parseISO(job.createdAt), 'PPp')}
          </Typography>
          {job.settings && (
            <Typography variant="body2">
              Custom settings: {JSON.stringify(JSON.parse(job.settings), null, 2)}
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default JobDetails;
